import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import {
  GeneratePreviewDocument,
  GeneratePreviewMutation,
  GeneratePreviewMutationVariables,
  PossibleProject,
  PossibleVariation,
} from '../generated/graphql';
import mutationVariables from '../utility/mutationVariables';

export const usePreview = ({
  projectType,
  variation,
}: {
  projectType: PossibleProject['project_type'];
  variation: PossibleVariation;
}) => {
  const [generatePreview, { data }] = useMutation<GeneratePreviewMutation, GeneratePreviewMutationVariables>(
    GeneratePreviewDocument,
    { context: { clientName: 'planbcd' } },
  );

  const setPreview = ({
    live = true,
    useProxy = false,
    version,
  }: { live?: boolean; useProxy?: boolean; version?: number } = {}): void => {
    if (projectType === 'redirect_test') {
      return;
    }
    if (variation.plan_a) {
      return;
    }
    generatePreview(
      mutationVariables({
        proxy: useProxy,
        live: live,
        variation: {
          href: version ? `${variation.href}?version=${version}` : variation.href,
        },
      }),
    );
  };

  const getPreview = async ({
    live = true,
    useProxy = false,
    version,
  }: { live?: boolean; useProxy?: boolean; version?: number } = {}) => {
    const { data: previewData } = await generatePreview(
      mutationVariables({
        proxy: useProxy,
        live: live,
        variation: {
          href: version ? `${variation.href}?version=${version}` : variation.href,
        },
      }),
    );
    return previewData;
  };

  useEffect(() => {
    setPreview();
  }, []);

  return { preview: data?.generatePreview, setPreview, getPreview };
};

type UsePreview = ReturnType<typeof usePreview>;
export type GetPreview = UsePreview['getPreview'];
export type GetPreviewParams = Parameters<UsePreview['getPreview']>[0];
